export const Practice = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_300_3777"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <path d="M14 0H0V14H14V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_300_3777)">
      <path
        d="M6 9.09668C5.50363 9.40142 5.15554 9.92436 5.09375 10.5332L5.08398 10.7285L5.09375 10.9248C5.19183 11.8909 6.00799 12.6445 7 12.6445C7.69127 12.6445 8.2949 12.2774 8.63184 11.7285H9.03711C8.66718 12.481 7.89517 13 7 13C5.74574 13 4.72852 11.9828 4.72852 10.7285C4.72869 9.83377 5.24792 9.06236 6 8.69238V9.09668ZM11.7285 4.96191C12.4812 5.33177 13 6.10469 13 7C13 8.25428 11.9828 9.27148 10.7285 9.27148C9.83376 9.27131 9.06236 8.75208 8.69238 8H9.09668C9.43356 8.54871 10.0375 8.91586 10.7285 8.91602C11.7866 8.91602 12.6445 8.0581 12.6445 7C12.6445 6.30854 12.2777 5.70407 11.7285 5.36719V4.96191ZM3.27148 4.72852C4.16622 4.72869 4.93764 5.24792 5.30762 6H4.90332C4.59858 5.50363 4.07564 5.15553 3.4668 5.09375L3.27148 5.08398C2.27964 5.08398 1.46354 5.83781 1.36523 6.80371L1.35547 7L1.36523 7.19629C1.42718 7.80494 1.7752 8.3272 2.27148 8.63184V9.03711C1.51897 8.66718 1 7.89517 1 7C1 5.74575 2.01723 4.72852 3.27148 4.72852ZM7 1C8.25427 1 9.27148 2.01723 9.27148 3.27148C9.27131 4.16607 8.75187 4.93659 8 5.30664V4.90234C8.54847 4.56541 8.91586 3.96233 8.91602 3.27148C8.91602 2.27964 8.16218 1.46354 7.19629 1.36523L7 1.35547C6.30872 1.35547 5.7051 1.72258 5.36816 2.27148H4.96289C5.33283 1.51897 6.10485 1 7 1Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  </svg>
);
